import React from "react";
import Navbar from "../../Shared/Navbar/Navbar";
import Footer from "../../Shared/Footer/Footer";
import { ReactTyped } from "react-typed";
import VideoCarousel from "./CarouselVideo";
import Donation from "../Home/Donation";

const Vlog = () => {
  return (
    <>
      {/* Hero Section Container */}
      <div className="relative bg-vlogImg sm:bg-bannerImg-sm md:bg-bannerImg-md lg:bg-bannerImg-lg bg-cover bg-center w-full h-[65vh] flex flex-col justify-between">
        {/* Subtle top shading overlay ensuring text-white contrast for transparent Navbar link visibility */}
        <div className="absolute inset-x-0 top-0 h-32 bg-gradient-to-b from-black/50 to-transparent pointer-events-none z-10" />

        <div className="relative w-full z-20">
          <Navbar />
        </div>

        {/* Typing Headliner Layer */}
        <div className="relative z-10 flex-1 flex flex-col items-center justify-center text-center px-4 max-w-4xl mx-auto">
          <span className="text-xs sm:text-sm font-bold tracking-widest uppercase text-emerald-800 bg-stone-100/90 px-4 py-1.5 rounded-full backdrop-blur-sm mb-3 shadow-sm">
            Watch Our Media
          </span>
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-black text-slate-900 tracking-tight leading-tight mb-2">
            Mohammadia Baria Jam E Masjid
          </h1>
          <div className="h-10 text-xl sm:text-2xl font-bold text-emerald-800">
            <ReactTyped
              strings={[
                "Videos & Community Vlogs",
                "Sacred Events & Gatherings",
              ]}
              typeSpeed={80}
              backSpeed={60}
              loop
            />
          </div>
        </div>

        <div className="h-12 w-full bg-gradient-to-t from-stone-50 to-transparent" />
      </div>

      {/* Structured Content Segments */}
      <div className="bg-stone-50/50">
        <VideoCarousel
          title={"Mosque Video"}
          paragraph={"Welcome to our mosque vlog"}
        />
        <Donation />
      </div>

      <Footer />
    </>
  );
};

export default Vlog;
